module.exports = __webpack_public_path__ + "static/media/bridge-black-green.dc1fc6a3.svg";